/** Formats a UZS amount as "10,000 UZS" / "34,999,999 UZS". */
export function formatUZS(amount: string | number | null | undefined): string {
  if (amount === null || amount === undefined) return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(n)) return '—';
  return `${new Intl.NumberFormat('en-US').format(Math.round(n))} UZS`;
}

function toDate(input: unknown): Date | null {
  if (input instanceof Date) return Number.isNaN(input.getTime()) ? null : input;
  if (typeof input === 'string' || typeof input === 'number') {
    const d = new Date(input);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function localeFor(lang: string): string {
  return lang === 'ru' ? 'ru-RU' : lang === 'en' ? 'en-US' : 'uz-UZ';
}

export function formatDate(input: unknown, lang = 'uz'): string {
  const d = toDate(input);
  if (!d) return '—';
  return d.toLocaleDateString(localeFor(lang), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function shortDate(input: unknown, lang = 'uz'): string {
  const d = toDate(input);
  if (!d) return '—';
  return d.toLocaleDateString(localeFor(lang), { day: '2-digit', month: 'short' });
}
